"use client";
import "../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { CpslIcon, CpslInput, CpslSelect, CpslSelectItem, CpslText, CpslTileButton } from "@getpara/react-components";
import { styled } from "styled-components";
import { MOBILE_SIZE, NETWORKS, ON_RAMP_ASSETS } from "../constants/constants.js";
import { useThemeStore } from "../stores/index.js";
const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const QRContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 286px;
  height: 286px;
`;
const InfoBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const InfoBoxHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  cpsl-icon {
    --height: 20px;
    --width: 20px;
  }
`;
const FilledDisabledInput = styled(CpslInput)`
  --container-border-color: var(--cpsl-color-input-border-placeholder);
  --container-background-color: var(--cpsl-color-background-0);
  --input-background-color: transparent;
  --input-font-weight: 500;
  --input-color: var(--cpsl-color-text-secondary);
`;
const FullWidthFilledDisabledInput = styled(FilledDisabledInput)`
  width: 100%;
`;
const CenteredText = styled(CpslText)`
  width: 100%;
  text-align: center;
`;
const InnerStepContainer = styled.div`
  width: 100%;
  height: 100%;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
const StepContainer = styled(InnerStepContainer)`
  gap: ${({ $wide }) => $wide ? "32px" : "24px"};
`;
const Heading = styled(CenteredText)``;
const StyledCpslTileButton = styled(CpslTileButton)`
  --button-width: 100%;
  --button-height: 87px;
  --button-icon-height: 32px;
  --button-icon-width: 32px;
`;
const HeroIcon = styled(CpslIcon)`
  --height: 80px;
  --width: 80px;
  --icon-color: var(--cpsl-color-text-primary);
`;
const HeaderSelect = styled(CpslSelect)`
  --container-height: auto;
  --container-border-width: 0px;
  --container-padding-end: 0px;
  --container-padding-start: 0px;
  --container-background-color: transparent;
  --container-box-shadow: none;
  --container-gap: 2px;
  --icon-width: 16px;
  --icon-height: 16px;
  position: relative;

  &::part(selected-text) {
    white-space: nowrap;
  }

  &::part(dropdown) {
    min-width: ${({ $width }) => `${$width - 2}px`};
  }

  &::part(popover) {
    /* Have to adjust the top of the popover here since we're using a transform on the modal which causes fixed position items to not be relative to the viewport */
    @media (max-width: ${MOBILE_SIZE}px) {
      top: ${({ $top }) => $top ? `${$top}px` : "0px"};
      bottom: 16px;
    }
    cpsl-auth-modal.force-mobile-media & {
      top: ${({ $top }) => $top ? `${$top}px` : "0px"};
      bottom: 16px;
    }
  }

  &::part(icon) {
    --icon-color: var(--cpsl-color-contrast);
  }
`;
const HeaderSelectItem = styled(CpslSelectItem)`
  --outer-container-padding-start: 4px;
  --outer-container-padding-end: 4px;
  --outer-container-padding-top: 4px;
  --outer-container-padding-bottom: 4px;
`;
const HeaderSelectContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 1000px;
  background-color: var(--cpsl-color-background-8);
  padding: 4px;
`;
const StyledIcon = styled(CpslIcon)`
  background: var(--cpsl-color-background-0);
  border-radius: 100%;
`;
function AssetIcon({ asset, size }) {
  const isDark = useThemeStore((state) => state.isDark);
  const data = ON_RAMP_ASSETS[asset];
  return /* @__PURE__ */ jsx(StyledIcon, { size, icon: data.icon, inset: data.isCircular ? void 0 : "15%", invert: isDark && data.isDark });
}
function NetworkIcon({ network, size }) {
  const isDark = useThemeStore((state) => state.isDark);
  const data = NETWORKS[network];
  return /* @__PURE__ */ jsx(StyledIcon, { size, icon: data.icon, inset: data.isCircular ? void 0 : "15%", invert: isDark && data.isDark });
}
const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const ErrorIcon = styled(CpslIcon)`
  --height: 16px;
  --width: 16px;
  --icon-color: var(--cpsl-color-text-error);
`;
export {
  AssetIcon,
  CenteredText,
  ErrorContainer,
  ErrorIcon,
  FilledDisabledInput,
  FullWidthFilledDisabledInput,
  HeaderSelect,
  HeaderSelectContainer,
  HeaderSelectItem,
  Heading,
  HeroIcon,
  InfoBoxContent,
  InfoBoxHeader,
  InnerStepContainer,
  NetworkIcon,
  QRContainer,
  SpinnerContainer,
  StepContainer,
  StyledCpslTileButton
};
